import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr20 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        ЗА ВКЛЮЧВАНЕ НА ДОМАШНИ КЛИЕНТИ
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        A1 България ЕАД
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Включване на домашни клиенти</b>
      </Typography>
      <Typography>1.1. Включване на домашни клиенти в LAN мрежа</Typography>
      <Typography>1.1.1. Включване на домашен клиент в ниско строителство</Typography>
      <Typography>
        Сграда от тип &quot;ниско стрителство&quot; - къща или малка кооперация до 3 апартамента.
        След оглед на трасето и подходите към дома на клиента се изтегля патч кабел от абонатната
        кутия с комутатор до дома на клиента. Когато кабелът се тегли по каналната мрежа се спазват
        всички правила посочени в по-горе. В случаите, когато кабела се монтира по стълбната мрежа
        се спазват инструкциите по-горе . След изтеглянето на кабела до дома на клиента се монтират
        RJ 45 конектори в двата му края по B standard на CISCO. Укрепването на кабела от абонатната
        кутия до дома на клиента и в дома на клиента става посредством закрепване за стената със
        скоби, като се допуска да бъде монтиран и кабел канал в случаите когато клиента пожелае
        това. Ако в дома на клиента има изградена слаботокова инсталация и при желание на клиента,
        тя се използва за прокарване на кабела.
      </Typography>
      <div style={styles.imgWrapper}>
        <img
          style={styles.img}
          src={`${process.env.PUBLIC_URL}/images/Untitled4.png`}
          alt="instruction-img"
        />
      </div>

      <Typography>
        След като двата конектора са монтирани, единият край на кабела се включва на свободен порт
        на комутатора в абонатната кутия, след което задължително се надписва с номера на
        апартамента на клиента.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled1.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        В случаите, когато няма свободни портове на сплитера се прилагат указанията по-горе. Другият
        край се включва в компютъра в жилището на клиента. След индикация за оптичен link се
        въвеждат и IP настройките му. В случаите, когато клиента ще ползва повече от едно устройства
        (компютър, телевизор,WiFi рутер) се изгражда медна мрежа от комутатор до всяко устройство на
        портебителя.
      </Typography>
      <Typography>1.1.2. Включване на домашен клиент във високо строителство</Typography>

      <Typography>
        Сграда от тип &quot;високо стрителство&quot; - жилищна кооперация или офис сграда с повече
        от 3 домакинства. Изтегля се патч кабел от абонатната кутия с комутатор, предназначен за
        апартаментите от етажа до дома на клиента. Кабелът се полага задължително в слаботоковата
        инсталация на сградата, а когато такава липсва или е непроходима се изграждат кабелни канали
        вертикално между етажите по вече описаните правила.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled3.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        След изтегянето на кабела до дома на клиента се монтират RJ 45 конектори в двата му края по
        B standard на CISCO. Укрепването на кабела от абонатната кутия до дома на клиента и в дома
        на клиента става посредством закрепване за стената със скоби, като се допуска да бъде
        монтиран и кабел канал в случаите когато клиента пожелае това. Ако в дома на клиента има
        изградена слаботокова инсталация и при желание на клиента, тя се използва за прокарване на
        кабела.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled4.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        След като двата конектора са монтирани, единият край на кабела се включва на свободен порт
        на комутатора в абонатната кутия, след което задължително се надписва с номера на
        апартамента на клиента.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled1.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        В случаите, когато няма свободни портове на сплитера се прилагат указанията по-горе. Другият
        край се включва в компютъра в жилището на клиента. След индикация за оптичен link се
        въвеждат и IP настройките му. В случаите, когато клиента ще ползва повече от едно устройства
        (компютър, телевизор,WiFi рутер) се изгражда медна мрежа от комутатор до всяко устройство на
        портебителя.
      </Typography>

      <Typography>1.2. Включване на клиент в GPON мрежа</Typography>
      <Typography>1.2.1. Включване на домашен клиент в ниско строителство</Typography>
      <Typography>
        Сграда от тип &quot;ниско стрителство&quot; - къща или малка кооперация до 3 апартамента.
        След оглед на трасето и подходите към дома на клиента се изтегля оптичен кабел (корда) от
        абонатната кутия със сплитер до дома на клиента. Може да се използва FO-02 с носещо въже
        (черен) или FO-01 армиран (кръгъл, черен) в зависимост от това дали се изтегля въздушно по
        стълбовете или се полага подземно в каналната мрежа.
      </Typography>
      <Typography>
        Когато кабела се тегли по каналната мрежа се спазват всички правила описани до сега. СЪщото
        важи и когато кабела се монтира по стълбната мрежа. След изтегянето на кабела до дома на
        клиента се монтират FAST конектори в двата му края. На края на кабела, който се намира в
        дома на клиента се монтира APC а в края на кабела в абонатната кутия -PC конектор.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled5.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        Укрепването на кабела в дома на клиента става посредством закрепване за стената със скоби,
        като се допуска да бъде монтиран и кабел канал в случаите когато клиента пожелае това. Ако в
        дома на клиента има изградена слаботокова инсталация и при желание на клиента, тя се
        използва за прокарване на кабела.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled4.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        След като двата конектора са монтирани, единият край на кабела се включва на свободен порт
        на сплитера в абонатната кутия, след което задължително се надписва с номера на апартамента
        на клиента. Другия край се включва в единствения порт на ONT устройството.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled7.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        Непосредствено преди включването на конекторите се извършва почистването им с NEOCLEAN.
      </Typography>

      <Typography>
        След като ONT устройството е включено в ел.мрежа и индикацията за оптичен link свети, следва
        устройството да се свърже с компютъра или компютърната мрежа на клиента.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled8.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        В случаите, Kогато клиента ще ползва повече от едно устройства (компютър, телевизор, рутер)
        се изгражда медна мрежа от ONT устройството до всяко устройство на портебителя, при спазване
        на правилата в т.10.3 ONT устройството се активира чрез въвеждане на PIN код на
        <span>http://pin.spnet.net/. </span> След активацията се проверява дали устройствата работят
        коректно и се дават разяснения на клиента как да борави с ONT устройството.
      </Typography>

      <Typography>1.2.2. Включване на домашен клиент във високо строителство</Typography>

      <Typography>
        Сграда от тип &quot;високо стрителство&quot; - жилищна кооперация или офис сграда с повече
        от 3 домакинства. Изтегля се оптичен кабел (корда) от абонатната кутия със сплитер,
        предназначена за апартаментите от етажа до дома на клиента. Може да се използва FO-01
        неармиран (претерминиран, бял) или FO-01 неармиран (кръгъл, бял). Кабелът се полага
        задължително в слаботоковата инсталация на сградата, а когато такава липсва или е
        непроходима се изграждат кабелни канали вертикално между етажите по правилата .
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled3.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        След изтегянето на кабела до дома на клиента се монтират FAST конектори в двата му края. На
        края на кабела, който се намира в дома на клиента се монтира APC а в края на кабела в
        абонатната кутия -PC конектор (когато използвания кабел не е претерминиран) . Монтират фаст
        конектори от двата края на кабела като от страната на клиента се монтира APC а от страната
        на сплитерната кутия PC (когато кордата не е претерминирана).
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled5.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        Укрепването на кабела от абонатната кутия до дома на клиента и в дома на клиента става
        посредством закрепване за стената със скоби, като се допуска да бъде монтиран и кабел канал
        в случаите когато клиента пожелае това. Ако в дома на клиента има изградена слаботокова
        инсталация и при желание на клиента, тя се използва за прокарване на кабела.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled4.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        След като двата конектора са монтирани, единият край на кабела се включва на свободен порт
        на сплитера в абонатната кутия, след което задължително се надписва с номера на апартамента
        на клиента. Другия край се включва в единствения порт на ONT устройството.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled7.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        Непосредствено преди включването на конекторите се извършва почистването им с NEOCLEAN. В
        случаите, когато няма свободни портове на сплитера се прилагат указанията След като ONT
        устройството е включено в ел.мрежа и индикацията за оптичен link свети, следва устройството
        да се свърже с компютъра или компютърната мрежа на клиента.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled7.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        В случаите, когато клиента ще ползва повече от едно устройства (компютър, телевизор, рутер)
        се изгражда медна мрежа от ONT устройството до всяко устройство на портебителя, при спазване
        на правилата в т.10.3 ONT устройството се активира чрез въвеждане на PIN код на
        <span> http://pin.spnet.net/.</span>
      </Typography>
      <Typography>
        След активацията се проверява дали устройствата работят коректно и се дават разяснения на
        клиента как да борави с ONT устройството.
      </Typography>

      <Typography>1.3. Включване на допълнително устройство при съществуващ клиент</Typography>
      <Typography>
        Допълнително устройство се инсталира при клиент с вече налична услуга. Допълнителни
        устройства са: 8 портов неуправляем комутатор, WiFi рутер, Set-Top-Box (Hansun или ZTE),
        Power Line Adapter и други.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled10.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>
      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled11.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        Допълнителните устройства се включват към вече монтирания комутатор при клиента. Ако няма
        такъв, то се монтира като сигнала за него се свързва към абонатната кутия, от която е
        захранено жилището на клиента. За връзка между комутатора и допълнителните устройства се
        използва UTP cat 5e кабел. RJ 45 конекторитe се монтират на кабелите по B standard на CISCO.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled11.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        За ел.захранване на комутатора се използва фабричния трансформатор към него, който се
        включва в ел.мрежата.Когато няма подходяща точка от ел.мрежата на близко разстояние може да
        се използва Power Over Ethernet комплект, който да позволи адаптера да бъде включен дори в
        друга стая.
      </Typography>

      <div style={styles.imgWrapper}>
        <img
          src={`${process.env.PUBLIC_URL}/images/Untitled13.png`}
          style={styles.img}
          alt="instruction-img"
        />
      </div>

      <Typography>
        Всички Set-Top-Box устройства се активират чрез PIN код. След активацията на устройствата се
        дават разяснения на клиента за начина на експлоатация.
      </Typography>
    </div>
  );
};
export default Instr20;
